import React from 'react';
import type { BlockImageAndDescriptionList } from 'types/block-image-and-description-list';

import { Paragraph, Wrap } from '@leafwell/components';

import HeadingBody from './heading-body';
import Figure from './figure';

const ImageAndDescriptionList: React.FC<BlockImageAndDescriptionList> = ({
  sectionId,
  title,
  description,
  list,
}) => {
  return (
    <Wrap id={sectionId} className="gap-y-14 lg:gap-y-20">
      <div className="flex flex-col lg:flex-row justify-between gap-y-4 gap-x-8">
        {title?.length > 0 ? (
          <HeadingBody
            className="text-center lg:text-left lg:max-w-lg"
            level="2"
            title={title}
            tagName="h2"
          />
        ) : null}
        {description?.length > 0 ? (
          <Paragraph className="text-2xl text-center lg:text-left lg:max-w-lg leading-normal">
            {description}
          </Paragraph>
        ) : null}
      </div>
      {list?.length > 0 ? (
        <ul className="flex flex-col md:flex-row flex-wrap md:justify-center gap-x-16 gap-y-8">
          {list?.map(({ title, description, image }, idx) => {
            return (
              <li
                key={`${sectionId}-${idx}`}
                className={[
                  'grid grid-cols-auto-auto md:flex md:flex-col gap-8 md:w-72',
                ].join(' ')}
              >
                {image && (
                  <Figure
                    {...image}
                    className="grid md:items-end justify-center"
                    classNameImage="w-24 md:w-44"
                  />
                )}
                <div className="flex flex-col gap-y-2">
                  {title?.length > 0 && (
                    <HeadingBody
                      tagName="p"
                      level="5"
                      title={title}
                      className="font-medium md:text-center"
                    />
                  )}
                  {description?.length > 0 && (
                    <Paragraph
                      size="large"
                      tagName="div"
                      className="md:text-center"
                      dangerouslySetInnerHTML={{ __html: description }}
                    />
                  )}
                </div>
              </li>
            );
          })}
        </ul>
      ) : null}
    </Wrap>
  );
};

export default ImageAndDescriptionList;
